'use client';

import React from 'react';

const words = [
  'PHOTOGRAPHY', '\u25b8', 'VIDEOGRAPHY', '\u25b8', 'LIVE PRODUCTION', '\u25b8',
  'BRANDING', '\u25b8',
];

export default function MarqueeBar() {
  const doubled = [...words, ...words];
  return (
    <div
      className="w-full overflow-hidden"
      style={{
        background: '#FFFFFF',
        padding: '12px 0',
        borderTop: 'none',
        borderBottom: 'none',
      }}
    >
      <div className="ticker-content">
        {doubled?.map((word, i) => (
          <span
            key={i}
            style={{
              fontFamily: 'Bebas Neue, sans-serif',
              fontSize: '14px',
              letterSpacing: '3px',
              marginLeft: '20px',
              marginRight: '20px',
              color: word === '\u25b8' ? 'rgba(0,0,0,0.4)' : '#0A0A0A',
            }}
          >
            {word}
          </span>
        ))}
      </div>
    </div>
  );
}
